import { useState } from 'react'
import {Checkbox, Table, TableCaption, TableContainer, Tbody, Th, Thead, Tr, Input, Button, Stack, Spacer} from '@chakra-ui/react'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import ItemsInvalidTableRow from './ItemsInvalidCheckInCatalog/ItemsInvalidTableRow'
import {ItemsTableCaption} from '../../ItemsTableCaption/ItemsTableCaption'
import {ItemsInvalidCheckInCatalog} from '../ItemsInvalidCheckInCatalog'
import {ItemsInvalidDelete} from './ItemsInvalidDelete/ItemsInvalidDelete'
// import { dataTool } from 'echarts'
//import { Filters } from 'components/Filters'

const Filters = ({filtersConfig = [], filters, setFilters }) => { 
    
    return (
        <Tr>
            <Th></Th>
            { filtersConfig.map((filter, idx) =>
                <Th key={idx}>
                    <Input  
                        id={`filter_${filter.type}`} 
                        placeholder={filter.placeholder} 
                        onChange={(e) => setFilters({...filters, [filter.type]: e.target.value || undefined })} 
                        value={filters ? (filters[filter.type] ?? '') : null}
                        type={filter.type.startsWith('date') ? 'date' : 'text'}
                    />
                </Th>
            )}
        </Tr>
    )
}

export const ItemsInvalidTable = (props) => {
    const {itemsInvalid, itemsInvalidCount, itemsInvalidSumAmount, itemsInvalidRows, onCheckboxChange,
        checkAllSelected, isCheckingAll, handleSelectAll, selectAll, itemsSelected, refreshTable, isDeletingAll,
        deleteAllSelected, refreshCounting} = props

    const [isLoading, setIsLoading] = useState(false)

    const donwloadExcel = async (data, fileName) => {
        setIsLoading(true)
        try {
            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('Items Invalid')
            worksheet.columns = [
                { header: 'UPC', key: 'upc', width: 20 },
                { header: 'MKT', key: 'mkt_1', width: 10 },
                { header: 'Row', key: 'row_name', width: 15 },
                { header: 'Amount', key: 'amount', width: 10 },
                { header: 'Device', key: 'device_number', width: 15 },
                { header: 'Name', key: 'user_name', width: 25 }
            ]
            data.forEach(item => {
                worksheet.addRow({
                    upc: item.upc,
                    mkt_1: item.mkt_1,
                    row_name: item.row_name,
                    amount: item.amount,
                    device_number: item.device_number,
                    user_name: `${item.user?.name} ${item.user?.last_name}`
                })
            })
            const buffer = await workbook.xlsx.writeBuffer()
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            saveAs(blob, `${fileName}.xlsx`)
        } catch (error) {
            console.error('Error downloading Excel:', error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <TableContainer>
            <Table>
                <TableCaption placement={'top'}>
                    <Stack direction='row' spacing={4} alignItems='center'>
                    <ItemsTableCaption
                        totalAmount={itemsInvalidSumAmount}
                        total={itemsInvalidCount}
                        totalRows={itemsInvalidRows.length}
                    />
                    <Spacer />
                    <Button
                        onClick={() => donwloadExcel(itemsInvalid, 'items_invalid')}
                        colorScheme='teal'
                        size='sm'
                        isLoading={isLoading}
                        loadingText='Downloading...'
                    >
                        Download
                    </Button>
                    </Stack>
                </TableCaption>
                <Thead>
                    
                    <Filters filtersConfig={[
                                { type: 'upc', placeholder: 'UPC' },
                                { type: 'mkt_1', placeholder: 'MKT' },
                                { type: 'row_name', placeholder: 'Row' },
                                { type: 'amount', placeholder: 'Amount'},
                                { type: 'device_number', placeholder: 'Device' },
                                { type: 'user', placeholder: 'Name' },
                            ]} 
                            filters={props.filters} setFilters={ props.setFilters }/>
                    <Tr>
                        <Th>
                            <Checkbox border={'1px'} isChecked={selectAll} onChange={handleSelectAll} />
                        </Th>
                        <Th>UPC</Th><Th>MKT</Th><Th>Row</Th><Th>Amount</Th><Th>Device</Th><Th>Name</Th>
                        <Th>
                            <ItemsInvalidCheckInCatalog isChecking={isCheckingAll} checkAllSelected={checkAllSelected} />
                            <ItemsInvalidDelete isDeleting={isDeletingAll} deleteAllSelected={deleteAllSelected} />
                        </Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {itemsInvalid.map(item => (
                        <ItemsInvalidTableRow
                            key={item._id}
                            id={item._id}
                            upc={item.upc}
                            device={item.device_number}
                            row={item.row_name}
                            mkt={item.mkt_1}
                            amount={item.amount}
                            name={`${item?.user?.name} ${item?.user?.last_name}`}
                            onCheckboxChange={onCheckboxChange}
                            itemsSelected={itemsSelected}
                            selectAll={selectAll}
                            refreshTable={refreshTable}
                            refreshCounting={refreshCounting}
                        />
                    ))}
                </Tbody>
            </Table>

        </TableContainer>
    )
}